import React from 'react';
import { siteData } from '../data';
import * as Icons from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Services() {
  return (
    <section id="services" className="relative pt-24 pb-0 lg:pb-24 bg-blue-950 overflow-hidden">
      {/* Triangle Watermark */}
      <div className="hidden md:block absolute bottom-0 right-0 -mb-24 -mr-24 w-96 h-96 opacity-5 md:opacity-5 pointer-events-none">
        <svg viewBox="0 0 100 100" fill="currentColor" className="text-blue-900 md:text-white w-full h-full transform rotate-12">
          <polygon points="0,100 100,100 100,0" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto">
          {siteData.services.map((service, index) => {
            const Icon = Icons[service.icon];
            return (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group relative"
              >
                <div className="h-full bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 lg:p-10 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-500/10">
                  <div className="w-14 h-14 bg-blue-600/20 rounded-2xl flex items-center justify-center text-blue-400 mb-8 group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                    <Icon size={28} />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
                  <p className="text-blue-50/70 leading-relaxed mb-8 text-lg">
                    {service.description}
                  </p>
                  <Link 
                    to={`/services/${service.slug}`}
                    className="inline-flex items-center text-white font-semibold group/link"
                  >
                    <span className="border-b-2 border-blue-500/30 group-hover/link:border-blue-400 transition-colors pb-1">
                      Læs mere om {service.title.toLowerCase()}
                    </span>
                    <Icons.ArrowRight className="ml-2 w-5 h-5 transform group-hover/link:translate-x-1 transition-transform text-blue-400" />
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-20 rounded-none -mx-4 sm:-mx-6 lg:mx-0 lg:rounded-2xl bg-white shadow-none md:shadow-none lg:shadow-xl border-none grid lg:grid-cols-2"
        >
          <div className="bg-gray-50 sm:bg-transparent px-4 py-10 sm:p-12 lg:p-16 flex flex-col justify-center">
            <h3 className="text-2xl sm:text-3xl font-bold mb-6 px-2 sm:px-0">Altid rene ruder med en fast aftale</h3>
            <p className="text-base sm:text-lg text-gray-600 mb-8 leading-relaxed px-2 sm:px-0">
              De fleste af vores kunder vælger en abonnementsløsning. Det sikrer, at dine vinduer altid står skarpt, uden at du skal tænke på at bestille hver gang. 
              Du vælger selv frekvensen – vi foreslår typisk hver 8. uge for det bedste resultat.
            </p>
            <div className="space-y-4 px-2 sm:px-0">
              {siteData.benefits.map((benefit, i) => (
                <div key={i} className="flex items-start space-x-3">
                  <div className="mt-1 text-black flex-shrink-0">
                    <Icons.Check size={20} strokeWidth={3} />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{benefit.title}</h4>
                    <p className="text-gray-600">{benefit.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="block h-80 md:h-[500px] lg:h-auto relative p-0 lg:p-8 rounded-none lg:rounded-r-3xl overflow-hidden bg-white">
            <img 
              src={siteData.images.villa} 
              alt="Hus med rene vinduer" 
              className="w-full h-full lg:h-auto lg:aspect-square object-cover rounded-none lg:rounded-2xl shadow-none lg:shadow-lg lg:-mt-16 lg:mb-8"
            />
            <div className="hidden lg:block absolute bottom-8 right-12 text-white/20 pointer-events-none select-none transform rotate-12 translate-x-1/4 translate-y-1/4">
              <svg 
                width="160" 
                height="160" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="1" 
                strokeLinecap="square" 
                strokeLinejoin="miter"
              >
                <path d="M2 4h20v2H2z" />
                <path d="M11 6h2v14h-2z" />
                <path d="M8 20h8" />
              </svg>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
